import React from 'react'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,Grid ,TextField} from '@material-ui/core'
import { Autocomplete,  } from '@material-ui/lab';

export default function RejectedStatusChangeModal({ toggleModalFn,error,updateApprover,updateErrorField,workingGroupConfig ,onRejectSave,loadingButton,approverLoader}) {
const desiredOrder = ["Finance Control", "Accounting Control"];

const updatedWorkingGroupConfig = desiredOrder
  .map(key => {
    const item = workingGroupConfig[key];
    return { ...item, stageIndex: desiredOrder.indexOf(key) + 1 };
  });
    return (
        <div>
            <Dialog open='true' maxWidth="sm" fullWidth >
                <DialogTitle>Rejected Status Change</DialogTitle>
                <DialogContent dividers={true}  >
                    <Grid md={12}>
                        <Autocomplete
                            options={updatedWorkingGroupConfig}
                            getOptionLabel={(option) => option?.name || ''}
                            disabled={approverLoader}
                            // value={approvalStageArr.find((opt) => opt.value === this.state.formData.working_group_id) || null}
                            onChange={(e, value) => updateApprover('rejected_stage_working_group', value)}
                            onFocus={() => updateErrorField('rejected_stage_working_group', '')}
                            renderInput={params => <TextField disabled={approverLoader}  required error={error.rejected_stage_working_group ? true : false} helperText={error.rejected_stage_working_group || ''}   {...params} label="Rejected To" margin="normal" fullWidth InputLabelProps={{ shrink: true }} />}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginLeft: "15px" }} disabled={approverLoader} color="primary" size='small' variant='outlined' onClick={toggleModalFn}>Close</Button>
                    <Button style={{ marginLeft: "15px" }} disabled={approverLoader}  color='primary' variant='contained' size='small'   onClick={onRejectSave}>{loadingButton === 'reject' && approverLoader ?<CircularProgress size={20}/>:"Save"}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
